import { render, staticRenderFns } from "./wordChart.vue?vue&type=template&id=99d4c9ae"
import script from "./wordChart.vue?vue&type=script&lang=js"
export * from "./wordChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d4c9ae')) {
      api.createRecord('99d4c9ae', component.options)
    } else {
      api.reload('99d4c9ae', component.options)
    }
    module.hot.accept("./wordChart.vue?vue&type=template&id=99d4c9ae", function () {
      api.rerender('99d4c9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/other/components/wordChart.vue"
export default component.exports